import { render, staticRenderFns } from "./PerDevice.vue?vue&type=template&id=614c24fa&scoped=true&"
import script from "./PerDevice.vue?vue&type=script&lang=js&"
export * from "./PerDevice.vue?vue&type=script&lang=js&"
import style0 from "./PerDevice.vue?vue&type=style&index=0&id=614c24fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614c24fa",
  null
  
)

export default component.exports